"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var editableCell_1 = require("./editableCell");
var bulkEdit_1 = require("./bulkEdit");
var typestyle_1 = require("typestyle");
var RowsDetail = (function (_super) {
    __extends(RowsDetail, _super);
    function RowsDetail(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            bimHandler: null,
            bimHighlight: false,
        };
        return _this;
    }
    RowsDetail.prototype.componentDidMount = function () {
        var _this = this;
        var handler = function (message) {
            if (message.id == _this.props.id) {
                _this.setState({
                    bimHighlight: true
                });
            }
            else {
                _this.setState({
                    bimHighlight: false
                });
            }
        };
        try {
            intercom.onMessage("BIM", "clickRisk", handler);
        }
        catch (ReferenceError) { }
        this.setState({
            'bimHandler': handler
        });
    };
    RowsDetail.prototype.componentWillUnmount = function () {
        try {
            intercom.off("BIM", "clickRisk", this.state.bimHandler);
        }
        catch (ReferenceError) { }
        this.setState({
            'bimHandler': null
        });
    };
    RowsDetail.prototype.render = function () {
        var _this = this;
        var bimHighlight = this.state.bimHighlight ? "EditableList__Row--bimhighlight" : "";
        return (React.createElement("tr", { className: (0, typestyle_1.classes)("EditableList__Row", bimHighlight) },
            this.props.inBulkEditMode && (React.createElement(bulkEdit_1.RowSelectorCell, { row: this.props.row, onChange: this.props.onRowSelected, isRowSelected: this.props.isRowSelected })),
            this.props.fields.map(function (field, index) { return ((0, editableCell_1.dispatchEditableCell)(__assign({ field: field, column: _this.props.columns[index], url: _this.props.url, inBulkEditMode: _this.props.inBulkEditMode, onClickLink: _this.props.onClickLink, performRowUpdate: _this.props.performRowUpdate, refetchTable: _this.props.refetchTable }, (_this.props.relationProps || {})[_this.props.columns[index].id]))); })));
    };
    return RowsDetail;
}(React.Component));
exports.default = RowsDetail;
